import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withFormsy } from "formsy-react";

import { coreActions } from "./actions/core.actions";
import { AsyncSelect } from "../Shared/Forms";

export class CoreDomains extends Component {
  
  componentDidMount(){
    if(this.props.value){
      this.props.getCoreDomains({ domainCode: this.props.value });
    }
  }

  getCoreDomains = (inputValue, callback) => {
    if ((inputValue && inputValue.length > 2)) {
      this.props.getCoreDomains({ domainCode: inputValue });
      callback(this.props.response);
    }
  };

  render() {
    const { name, disabled, response, value } = this.props;

    const selectedValue =
      response && response.filter(domain => domain.code === value);

    return (
      <div>
        <AsyncSelect
          name={name}
          value={selectedValue && selectedValue[0]}
          title="Domains"
          loadOptions={this.getCoreDomains}
          valueKey="code"
          disabled={disabled}
          labelKey="name"
          validating={disabled}
          innerRef={c => {
            this.domainCode = c;
          }}
          isClearable={true}
          required
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { fetching, fetched, response, error } = state.coreDomains;
  return {
    fetching,
    fetched,
    response,
    error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCoreDomains: bindActionCreators(coreActions.getCoreDomains, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withFormsy(CoreDomains));
